import { render, staticRenderFns } from "./ChatSingleDetails.vue?vue&type=template&id=ed568fca&"
import script from "./ChatSingleDetails.vue?vue&type=script&lang=js&"
export * from "./ChatSingleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports